Monet.UI = Monet.UI || {};
Monet.UI.Fields = Monet.UI.Fields || {};

Monet.UI.Fields.Repetition = (function () {

    function Repetition () {
        Monet.UI.Fields.Base.apply(this, arguments);

        this.runEveryInput = null;
        this.value = "";
        this.label = null;
        this.selectedDaysOfWeekValue = [];

        this.createElements = function () {
            this.rootEl = document.createElement('div');
            this.rootEl.className += ' repetition';

            const labelTextNode = document.createTextNode(Monet.I18n.getResourcesByKey('RepetitionField.label'));
            this.label = document.createElement('label');
            this.label.appendChild(labelTextNode);

            const runEveryTextNode = document.createTextNode(Monet.I18n.getResourcesByKey('RepetitionField.repeatEvery'));
            this.runEveryLabel = document.createElement('label');
            this.runEveryLabel.style.textAlign = "right";
            this.runEveryLabel.appendChild(runEveryTextNode);

            const options = [
                {
                    title: Monet.I18n.getResourcesByKey('RepetitionField.select'),
                    value: ''
                },
                {
                    title: Monet.I18n.getResourcesByKey('RepetitionField.day'),
                    value: 'DAY'
                },
                {
                    title: Monet.I18n.getResourcesByKey('RepetitionField.week'),
                    value: 'WEEK'
                },
                {
                    title: Monet.I18n.getResourcesByKey('RepetitionField.midMonth'),
                    value: 'MID_MONTH'
                },
                {
                    title: Monet.I18n.getResourcesByKey('RepetitionField.month'),
                    value: 'MONTH'
                },
                {
                    title: Monet.I18n.getResourcesByKey('RepetitionField.year'),
                    value: 'YEAR'
                }
            ];

            this.periodSelect = document.createElement('select');
            this.periodSelect.className = 'periodSelect';
            this.periodSelect.name = 'repeatType';
            options.forEach((item) => {
                const option = document.createElement("option");
                option.value = item.value;
                option.text = item.title;
                this.periodSelect.appendChild(option);
            });

            this.createDaysSelect();

            this.addListenersToPeriodSelect();

            this.variableContent = document.createElement('div');

            this.rootEl.appendChild(this.runEveryLabel);
            this.rootEl.appendChild(this.periodSelect);
            this.rootEl.appendChild(this.variableContent);
            this.renderTimeField();
        };

        this.isEmpty = function () {
            const type = this.periodSelect.value;
            const time = this.timeField.getValue();
            if(!type || !time) return true;

            switch(type) {
                case 'DAY':
                    if(!this.runEveryInput.value) return true;
                    break;
                case 'WEEK':
                    if(this.selectedDaysOfWeek().length == 0) return true;
                    break;
                case 'MONTH':
                    if(!this.daysSelect.value) return true;
                    break;
                case 'YEAR':
                    if(!this.daysSelect.value || !this.monthSelect.value) return true;
                    break;
            };
            return false;
        };

        this.controlShowingFields = (value) => {
            switch(value) {
                case '':
                    return;
                case 'DAY':
                    this.renderDayOption();
                    return;
                case 'WEEK':
                    this.renderWeekOption();
                    return;
                case 'MID_MONTH':
                    return;
                case 'MONTH':
                    this.renderMonthOption();
                    return;
                case 'YEAR':
                    this.renderYearOption();
                    return;
            }
        };

        this.selectedDaysOfWeek = function () {
            var daysOfWeekSelected = Array.from(this.rootEl.querySelectorAll("input[name='daysOfWeek[]']:checked"));
            const daysOfWeekValues = daysOfWeekSelected.map((item) => item.value);
            return daysOfWeekValues;
        };

        this.handleChangeOnPeriodSelect = (ev) => {
            const value = ev.target.value;
            this.clearVariableContent();
            
            this.controlShowingFields(value);
        };

        this.addListenersToPeriodSelect = function() {
            this.periodSelect.addEventListener("change", this.handleChangeOnPeriodSelect);
        };

        this.clearVariableContent = function() {
            this.variableContent.innerHTML = ""; 
        };

        this.renderTimeField = function() {
            const timeFieldContent = document.createElement("div");
            timeFieldContent.className = "timeFieldContent";
            this.timeField = new Monet.UI.Fields.TimeField();
            this.timeField.setTextLabel(Monet.I18n.getResourcesByKey('RepetitionField.exactTimeExecution'));
            this.timeField.setInputName("timeOfExecution");
            const timeNodeElement = this.timeField.render();
            
            timeFieldContent.appendChild(timeNodeElement);
            this.rootEl.appendChild(timeFieldContent); 
        };

        this.renderYearOption = function() {
            const monthAndDayContent = document.createElement("div");
            monthAndDayContent.className = "monthAndDayContent";
            
            const textNode = document.createTextNode(Monet.I18n.getResourcesByKey('RepetitionField.date'));
            const label = document.createElement('label');
            label.appendChild(textNode);

            const months = [
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.january'),
                    value: 0
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.february'),
                    value: 1
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.march'),
                    value: 2
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.april'),
                    value: 3
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.may'),
                    value: 4
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.june'),
                    value: 5
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.july'),
                    value: 6
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.august'),
                    value: 7
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.september'),
                    value: 8
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.october'),
                    value: 9
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.november'),
                    value: 10
                },
                {
                    title: Monet.I18n.getResourcesByKey('Greenmile.Data.Months.december'),
                    value: 11
                },
            ];

            this.monthSelect = document.createElement("select");
            this.monthSelect.name = 'month';
            this.monthSelect.className = 'monthsSelect';
            const selectOption = document.createElement("option");
            selectOption.value = "";
            selectOption.text = Monet.I18n.getResourcesByKey('RepetitionField.select');
            this.monthSelect.appendChild(selectOption);

            months.forEach(item => {
                const option = document.createElement("option");
                option.value = item.value;
                option.text = item.title;
                this.monthSelect.appendChild(option);
            });

            this.daysSelect.innerHTML = "";
            const selectOptionDay = document.createElement("option");
            selectOptionDay.value = "";
            selectOptionDay.text = Monet.I18n.getResourcesByKey('RepetitionField.selectMonth');
            this.daysSelect.appendChild(selectOptionDay);

            this.addListenersToMonthSelect();

            monthAndDayContent.appendChild(label);
            monthAndDayContent.appendChild(this.monthSelect);
            monthAndDayContent.appendChild(this.daysSelect);
            this.variableContent.appendChild(monthAndDayContent);
        }

        this.addListenersToMonthSelect = function() {
            this.monthSelect.addEventListener("change", this.handleChangeOnMonthSelect);
        };

        this.handleChangeOnMonthSelect = (ev) => {
            const selectedValue = parseInt(ev.target.value);
            this.changeOptionsDaysSelect(selectedValue);
        }

        this.renderMonthOption = function() {
            const monthAndDayContent = document.createElement("div");
            monthAndDayContent.className = "monthAndDayContent";
            
            const textNode = document.createTextNode(Monet.I18n.getResourcesByKey('RepetitionField.day'));
            const label = document.createElement('label');
            label.appendChild(textNode);

            this.changeOptionsDaysSelect();

            monthAndDayContent.appendChild(label);
            monthAndDayContent.appendChild(this.daysSelect);
            this.variableContent.appendChild(monthAndDayContent);
        };

        this.createDaysSelect = () => {
            this.daysSelect = document.createElement("select");
            this.daysSelect.className = 'daysSelect';
            this.daysSelect.name = 'day';
            this.daysSelect.id = 'daysSelect';

            this.changeOptionsDaysSelect();
        };

        this.changeOptionsDaysSelect = function(month) {
            this.daysSelect.innerHtml = "";
            this.daysSelect.length = 0;
            if(month) {
                let qtdDays = 31;
                const monthsWithThirty = [4, 6, 9, 11];
                if(monthsWithThirty.includes(month)) {
                    qtdDays = 30;
                } else if(month === 2) {
                    qtdDays = 28;
                }

                this.daysSelect.length = 0;
                
                for(let i = 1; i <= qtdDays; i++) {
                    const option = document.createElement("option");
                    option.value = i;
                    option.text = i;
                    this.daysSelect.appendChild(option);
                }
            } else {
                for(let i = 1; i <= 31; i++) {
                    const option = document.createElement("option");
                    option.value = i;
                    option.text = i;
                    this.daysSelect.appendChild(option);
                }
            }
        };

        this.renderWeekDay = function(text, value) {
            const label = document.createElement("label");
            label.className = 'checkDayLabel';
            const checkbox = document.createElement("input");
            checkbox.type = "checkbox";
            checkbox.value = value;
            checkbox.name = "daysOfWeek[]";
            const textNode = document.createTextNode(text);
            const checkMark = document.createElement("span");
            checkMark.className = "checkmark";
            checkMark.appendChild(textNode);

            if (this.selectedDaysOfWeekValue.indexOf(value) > -1) {
                checkbox.checked = true;
            }
            
            label.appendChild(checkbox);
            label.appendChild(checkMark);

            return label;
        };

        this.renderDayOption = function(shouldNotBeFocused, value) {
            const { data } = document.createTextNode(Monet.I18n.getResourcesByKey('RepetitionField.runEvery'));
            const dayContent = document.createElement("div");
            const runEveryLabel = document.createElement('label');

            this.runEveryInput = document.createElement('input');
         
            this.runEveryInput.setAttribute('name', 'repeatEvery');
            this.runEveryInput.setAttribute('type', 'number');
            this.runEveryInput.setAttribute('class', 'runEvery');
            this.runEveryInput.setAttribute('name', 'repeatEvery');
            this.runEveryInput.setAttribute('min', '1');
            this.runEveryInput.setAttribute('max', '31');

            this.runEveryInput.onkeydown = (e) => {
                if(e.key === "." || e.key === "-" || e.key === "+") {
                    e.preventDefault();
                }
            }
            this.runEveryInput.onkeyup = (e) => {
                if(parseInt(e.target.value) > 31) {
                    this.runEveryInput.value = "31";
                } else if (parseInt(e.target.value) === 0) {
                    this.runEveryInput.value = "1";
                }
            }
            dayContent.classList.add("runEveryDay");
            runEveryLabel.innerText = data;

            if(value) {
                this.runEveryInput.value = value.repeatEvery;
            }

            dayContent.appendChild(runEveryLabel);
            dayContent.appendChild(this.runEveryInput);

            if(!shouldNotBeFocused) {
                this.runEveryInput.focus();
            }

            this.variableContent.appendChild(dayContent);
        };

        this.renderWeekOption = function() {
            const daysOfWeekContent = document.createElement('div');
            daysOfWeekContent.className = 'daysOfWeek';
            const daysContent = document.createElement('div');
            daysContent.className = "daysContent";

            const textNode = document.createTextNode(Monet.I18n.getResourcesByKey('RepetitionField.daysToRepeat'));
            const label = document.createElement('label');
            label.appendChild(textNode);

            const daysOfWeek = [
                {
                    title: Monet.I18n.getResourcesByKey('Calendar.days.abreviation.sunday'),
                    value: 1
                },
                {
                    title: Monet.I18n.getResourcesByKey('Calendar.days.abreviation.monday'),
                    value: 2
                },
                {
                    title: Monet.I18n.getResourcesByKey('Calendar.days.abreviation.tuesday'),
                    value: 3
                },
                {
                    title: Monet.I18n.getResourcesByKey('Calendar.days.abreviation.wednesday'),
                    value: 4
                },
                {
                    title: Monet.I18n.getResourcesByKey('Calendar.days.abreviation.thursday'),
                    value: 5
                },
                {
                    title: Monet.I18n.getResourcesByKey('Calendar.days.abreviation.friday'),
                    value: 6
                },
                {
                    title: Monet.I18n.getResourcesByKey('Calendar.days.abreviation.saturday'),
                    value: 7
                },
            ];

            
            daysOfWeek.forEach((day) => {
                const checkDay = this.renderWeekDay(day.title, day.value);
                daysContent.appendChild(checkDay);
            });
            
            daysOfWeekContent.appendChild(label);
            daysOfWeekContent.appendChild(daysContent);
            this.variableContent.appendChild(daysOfWeekContent);
        };

        this.getValue = function () {
            const type = this.periodSelect.value;
            const time = this.timeField.getValue().split(":");
            const hours = parseInt(time[0]);
            const minutes = parseInt(time[1]);
            const value = {
                type,
                hours,
                minutes,
            };

            switch(type) {
                case 'DAY':
                    value.repeatEvery = parseInt(this.runEveryInput.value);
                    break;
                case 'WEEK':
                    value.daysOfWeek = this.selectedDaysOfWeek();
                    break;
                case 'MONTH':
                    value.day = this.daysSelect.value;
                    break;
                case 'YEAR':
                    value.day = this.daysSelect.value;
                    value.month = this.monthSelect.value;
                    break;
            }
            return value;
        };

        this.leadingZeros = function(num, size) {
            let fullNumber = num + "";
            while (fullNumber.length < size) fullNumber = "0" + fullNumber;
            return fullNumber;
        }

        this.setValue = function (value) {
            if ( value && typeof value === 'object') {
                const type = value.type;
                const hours = value.hours;
                const minutes = value.minutes;
                const timeValue = `${this.leadingZeros(hours, 2)}:${this.leadingZeros(minutes, 2)}`;
                this.periodSelect.value = type;
                this.timeField.setValue(timeValue);
                
                switch(type) {
                    case 'DAY':
                        this.renderDayOption(true, value);
                        break;
                    case 'WEEK':
                        this.selectedDaysOfWeekValue = value.daysOfWeek;
                        this.renderWeekOption();
                        break;
                    case 'MONTH':
                        this.renderMonthOption();
                        this.daysSelect.value = value.day;
                        break;
                    case 'YEAR':
                        this.renderYearOption();
                        this.changeOptionsDaysSelect(value.month);
                        this.daysSelect.value = value.day;
                        this.monthSelect.value = value.month;
                        break;
                }
            }
        };

        this.render = function () {
            this.createElements();
            return this.rootEl;
        };
    }
    return Repetition;
}());